<template>
  <div>
    <div v-if="loading" id="loading">
      <div class="lds-ripple-loaded"></div>
    </div>
    <div class="content" v-show="!loading">
      <Menu />
      <Intro />
      <div id="vision" class="vision">
        <h2 v-html="$t('vision.title')"></h2>
        <p v-html="$t('vision.l1')"></p>
        <p> * * * </p>
        <p v-html="$t('vision.l2')"></p>
        <p> * * * </p>
        <p v-html="$t('vision.l3')"></p>
      </div>
      <Jonathan />
      <Services />
      <div id="contact" class="contact">
        <h1>{{ $t('contact.title') }}</h1>
        <div class="contact-icons">
          <a href="https://www.facebook.com/jonathan.faucher" target="blank">
            <font-awesome-icon icon="fa-brands fa-facebook" />
            <p>Facebook</p>
          </a>
          <a href="https://www.linkedin.com/in/jonathan-faucher-29456875/" target="blank">
            <font-awesome-icon icon="fa-brands fa-linkedin" />
            <p>Linkedin</p>
          </a>
          <a href="mailto:jonathan.faucher@gmail.com">
            <font-awesome-icon icon="fa-solid fa-envelope" />
            <p>Email</p>
          </a>
        </div>
      </div>
      <div class="footer">
        <img width="400px" class="footer-logo" src="../assets/logo.svg">
        <BR/>&copy; The FastLane Company 2022
        <BR/>We didn't track or collect any of your data while visiting this website
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Jonathan from "./Jonathan.vue"
import Intro from "./Intro.vue"
import Services from "./Services.vue"

export default {
  name: "FastLaneWebsite",
  components: { Menu, Jonathan, Intro, Services },
  data: function () {
    return {
      loading: true,
      width: 50,
    };
  },
  mounted: function () {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
};
</script>

<style>
.footer-logo {
  filter: brightness(0) invert(1);
}
.footer {
  background: linear-gradient(135deg, var(--flatui-color1) 0%, var(--flatui-color3) 100%);
  padding-bottom: 5rem;
  padding-top: 5rem;
  color: var(--flatui-color4);
}
.contact {
  background: linear-gradient(135deg, var(--flatui-color2) 0%, var(--flatui-color6) 100%);
  padding: 3rem 2rem;
}
.contact-icons {
  padding-top: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  font-size: 1.2rem;
}
.contact-icons>a {
  font-size: 4rem;
  color: var(--flatui-color4);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.9;
}
.contact-icons>a:hover {
  transform: translateY(-8px);
  opacity: 1;
  filter: drop-shadow(0 8px 20px rgba(0,0,0,0.2));
}
.contact-icons>a>p {
  font-size: 1rem;
  margin-top: 0.5rem;
  font-weight: 500;
}
.vision,.contact{
  font-size: 1.5rem;
  padding:2rem;
  line-height: 1.8;
}
.filler{
  background-color: var(--flatui-color1);
  padding-top:20px;
  padding-bottom: 20px;
}
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1)
}
.card>p{
  font-size: 1.2rem;
}
.card:hover{
  transform: translateY(-4px) scale(1.05);
}
.duree {
  font-weight: bold;
  
}
.bb {
  border-bottom: 1px solid rgba(255,255,255,0.15);
}
.lds-ripple-loaded {
  position: absolute;
  border: 4px solid var(--flatui-color4);
  background-color: #ffffff00;
  opacity: 0.5;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: lds-grow 1s;
  animation-fill-mode: forwards;
  border-color: var(--flatui-color4);
}
.content {
  background: linear-gradient(180deg, var(--flatui-color3) 0%, #1a202c 100%);
  overflow-x: hidden;
  width: 100vw;
  max-width: 100vw;
  box-sizing: border-box;
}
.company {
  overflow: hidden;
}
@keyframes lds-grow {
  0% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
  }
  100% {
    width: 100vw;
    height: 100vh;
    border-radius: 0%;
    border: 0px;
    opacity: 1;
    transform: scale(1);
    background: linear-gradient(135deg, var(--flatui-color1) 0%, var(--flatui-color3) 100%);
  }
}
.logo{
  filter: brightness(0) invert(1);
}

</style>
